import type { Bytes } from "@pdfking/tfunc"
import { ResponseContentType } from "@pdfking/tfunc"

import { UrlLoad } from "../../network/browser/UrlLoad"
import type { BlobType } from "../../types/BlobType"

const fromBlob = (blob: Blob, type: string): BlobType => ({
  size: blob.size as Bytes,
  type,
  slice: (start?: number, end?: number) =>
    fromBlob(blob.slice(start, end), type),
  arrayBuffer: () => blob.arrayBuffer(),
})

export const RemoteBlob = (url: string, type?: string): Promise<BlobType> =>
  UrlLoad(url).then(r =>
    r.blob().then(blob => fromBlob(blob, type ?? ResponseContentType(r)))
  )
